import React, { useContext } from "react";

import { useNavigate } from "react-router-dom";

import BtnPlain from "../../../../../../Components/Buttons/BtnPlain";

import { ActionBtn } from "../../../../../../Components/FinalTable";

import { FiEdit2 } from "react-icons/fi";

import { FaRegTrashAlt } from "react-icons/fa";

import useAxios from "../../../../../../Hooks/useAxios";

import useApp from "../../../../../../Hooks/useApp";

import useAllCash from "../hooks/useAllCash";
import AllCash from "../context/AllCash";
import usePouchCud from "../../../../Hooks/usePouchCud";

const TableActions = ({ doc }) => {
  const { data, setData, total, setTotal } = useContext(AllCash);
  const {deleteDoc} = usePouchCud()
  const navigate = useNavigate();
  const request = useAxios();
  const { setShowSuccessModal, setModalMessage } = useApp();

  const handleDelete = async () => {
    let res = await request({
      method: "DELETE",
      url: `hospital/consumable/${doc.id}`,
    });

    if (res !== "error") {
      await deleteDoc({name: "consumables", doc: res})
      setModalMessage("Consumable Deleted!");
      setShowSuccessModal(true);
    }
    let newDocs = data.filter((row) => (row.id === doc.id ? false : true));

    setData(newDocs);
    setTotal(total - 1);
  };

  return (
    <div className="flex-1">
      <ActionBtn next={() => navigate(`view/${doc.id}`)} showNext={false}>
        <div className=" gap-y-2 flex flex-col text-sm">
          <BtnPlain
            activeBgColor="white"
            bg="white"
            click={() => navigate(`edit/${doc.id}`)}
          >
            <div className=" gap-x-2 flex items-center active:opacity-50 cursor-pointer">
              <p className="  text-primary">
                <FiEdit2 />
              </p>
              <p className=" ">Edit Consumable</p>
            </div>
          </BtnPlain>
          <BtnPlain activeBgColor="white" bg="white" click={handleDelete}>
            <div className=" gap-x-2 flex items-center active:opacity-50 cursor-pointer">
              <p className="  text-red">
                <FaRegTrashAlt />
              </p>
              <p className=" ">Delete Consumable</p>
            </div>
          </BtnPlain>
        </div>
      </ActionBtn>
    </div>
  );
};

export default TableActions;
